// Where a create/edit form was opened from — decides where Back, Cancel and a finished submit land.
// Role can't answer this: a moderator reaches the form from the member feed too.
export const FORM_ORIGINS = {
  FEED: 'feed',
  ADMIN: 'admin',
} as const;
export type FormOrigin = (typeof FORM_ORIGINS)[keyof typeof FORM_ORIGINS];
